/**
 * Open sidebar navigation in mobile
 */
document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.getElementById('mobile-sidemenu-toggle');
    var mobile_sidemenu = document.getElementById('mobile-sidemenu');

    if (toggle && mobile_sidemenu) {
        toggle.addEventListener('click', function () {
            var isOpen = mobile_sidemenu.classList.toggle('-open');
            toggle.setAttribute('aria-expanded', isOpen);
        });
    }
});
